<template>
    <div id="move">
        <a-modal :title="movePatwaytype" :visible="visible" width="85%" @cancel="moveHandleCancel" :maskClosable=false :footer="null">
            <a-form :form="form" v-if="movePatwaytype == 'Move' ? true : false ">
                <a-form-item :label="$t('userlang.Warehouse')" :label-col="{ span: 3 }" :wrapper-col="{ span: 8 }">
                    <a-select show-search optionFilterProp="label" size="small" :disabled="wareHourseDis"
                              :placeholder="$t('publicLang.PleaseSelect')" @change="moveWarehouseChange" v-decorator="[
                            'warehouse',
                            {
                              initialValue: editInvMoveHeader.whsCode,
                              rules: [{
                                required: true,
                                message: $t('publicLang.Required')
                              }]
                            }
                          ]">
                        <a-select-option :value="item.whsCode" :key="item.whsCode" :label="item.whsName"
                                         v-for="item in wareHouseSelect">{{item.whsName}}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item :label="$t('pubGicSet.MoveLogic')" :label-col="{ span: 3 }" :wrapper-col="{ span: 8 }">
                    <a-select show-search optionFilterProp="label" size="small"
                              :placeholder="$t('publicLang.PleaseSelect')" @change="moveLogicChange" v-decorator="[
                            'moveLogic',
                            {
                              initialValue: editInvMoveHeader.logic,
                              rules: [{
                                required: true,
                                message:  $t('publicLang.Required')
                              }]
                            }
                          ]">
                        <a-select-option :key="item" v-for="item in movelogicSelectData" :value="item" :label="item">
                            {{item}}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item :label="$t('pubGicSet.Reason')" :label-col="{ span: 3 }" :wrapper-col="{ span: 8 }">
                    <a-select show-search optionFilterProp="label" size="small"
                              :placeholder="$t('publicLang.PleaseSelect')" @change="moveReasonChange" v-decorator="[
                            'moveReason',
                            {
                              initialValue: editInvMoveHeader.reasonCode,
                              rules: [{
                                required: false,
                                message:  $t('publicLang.Required')
                              }]
                            }
                          ]">
                        <a-select-option :label="item.codeDesc" v-for="item in moveReasonSelectData" :key="item.code"
                                         :value="item.code">{{item.codeDesc}}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item :label="$t('pubGicSet.Remarks')" :label-col="{ span: 3 }" :wrapper-col="{ span: 8 }">
                    <a-textarea :placeholder="$t('pubGicSet.Remarks')" :rows="3" size="small" v-model="remarksVal" />
                </a-form-item>
            </a-form>



            <a-row>
                <a-button size="small" class="mg5" @click="moveHandleCancel">{{ $t('publicLang.Close') }}</a-button>
                <a-popconfirm :title="$t('publicLang.Arecancel')" @confirm="moveCancel" :okText="$t('publicLang.Yes')"
                              :cancelText="$t('publicLang.No')">
                    <a-button size="small" class="mg5" type="primary" :disabled="moveHeaderUid != ''? false : true"
                              v-if="ifCancel">{{ $t('publicLang.Cancel') }}</a-button>
                </a-popconfirm>
                <a-popconfirm :title="$t('publicLang.Areconfirm')" @confirm="confirmMove" :okText="$t('publicLang.Yes')"
                              :cancelText="$t('publicLang.No')">
                    <a-button size="small" class="mg5" type="primary" :disabled="moveHeaderUid != '' ? false : true"
                              v-if="isCancelMoveEvent">{{ $t('publicLang.Confirm') }}</a-button>
                </a-popconfirm>

                <!--添加库位输入框,如果有值则代替下方列表To Location的值 Liyy 2023-3-30-->
                <b style="margin-left: 5px;">{{$t('pubGicSet.Location')}}:</b>
                <a-auto-complete style="width: 200px;border: 0px solid;" @search="handleSearch" :placeholder="$t('publicLang.PleaseSelect')" size="small" v-model="topLocation">
                    <template slot="dataSource">
                        <a-select-option v-for="item in completeData" :key="item.locationCode"  :value="item.locationCode">{{item.locationName}}</a-select-option>
                    </template>
                </a-auto-complete>
            </a-row>



            <a-row style="float:right;margin-bottom: 10px;" v-if="movePatwaytype == 'Move' ? true : false ">
                <a-button class="mlt" size="small" type="primary" @click="saveMoveHeader" v-if="isSaveClick">
                    {{ $t('publicLang.Save') }}</a-button>
                <a-button class="mlt" size="small" type="primary" :disabled="moveHeaderUid != '' ? false: true"
                          @click="addMoveTable" v-if="ifSearch">{{ $t('pubGicSet.Search') }}</a-button>
            </a-row>



            <a-row style="margin-bottom: 5px" type="flex" justify="end" v-if="movePatwaytype == 'Move' ? false : true">
                <a-col>
                    <a-pagination :pageSizeOptions="pageSizeOptions"
                                  :showTotal="total => `${$t('generic.totalOf')} ${pagingTotal} ${$t('generic.Records')}`" size="small" :total="pagingTotal"
                                  v-model="currentVal" :pageSize.sync="pagingSize" @change="tableChangePage"
                                  @showSizeChange="onShowSizeChange" showSizeChanger />
                </a-col>
            </a-row>




            <a-divider style="margin: 10px 0px" v-if="movePatwaytype == 'Move' ? true : false" />
            <vxe-table border resizable size="mini" :data="tableData">
                <template v-slot:empty>
                    <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                </template>
                <vxe-table-column field="recId" :title="$t('pubGicSet.RecID')" show-header-overflow="ellipsis"
                                  show-overflow="ellipsis" v-if="movePatwaytype == 'Move' ? false : true "></vxe-table-column>
                <vxe-table-column field="sku" :title="$t('pubGicSet.SKU')" show-header-overflow="ellipsis"
                                  show-overflow="ellipsis"></vxe-table-column>
                <vxe-table-column field="palletId" :title="$t('batchReceive.PalletID')" show-header-overflow="ellipsis"
                                  show-overflow="ellipsis"></vxe-table-column>
                <vxe-table-column field="cartonId" :title="$t('batchReceive.CartonID')" show-header-overflow="ellipsis"
                                  show-overflow="ellipsis"></vxe-table-column>
                <vxe-table-column field="logicalWh" :title="$t('pubGicSet.LogicalWH')" show-header-overflow="ellipsis"
                                  show-overflow="ellipsis"></vxe-table-column>
                <vxe-table-column field="holdBaseQty" :title="$t('batchReceive.HoldBaseQty')"
                                  show-header-overflow="ellipsis" show-overflow="ellipsis"
                                  v-if="movePatwaytype == 'Move' ? false : true "></vxe-table-column>
                <vxe-table-column field="availableQty" :title="$t('pubGicSet.AvailableQty')"
                                  show-header-overflow="ellipsis" show-overflow="ellipsis"
                                  v-if="movePatwaytype == 'Move' ? true : false "></vxe-table-column>
                <vxe-table-column field="fromLocation" :title="$t('pubGicSet.FromLocation')"
                                  show-header-overflow="ellipsis" show-overflow="ellipsis"></vxe-table-column>
                <vxe-table-column field="moveQty" :title="$t('pubGicSet.MoveQty')" show-header-overflow="ellipsis"
                                  show-overflow="ellipsis">
                    <template v-slot="{ row }">
                        <a-input-number :placeholder="$t('publicLang.PleaseEnter')" :min="0" :step="0.01"
                            :parser="v => v.replace(/[^\d.]/g, '').replace(/(\..*)\./g, '$1')"
                            :formatter="v => { const s = String(v); if (s.endsWith('.')) return s; return s.replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, ''); }"
                            v-model="row.moveQty" size="small" style="width: 100%;" />
                    </template>
                </vxe-table-column>
                <vxe-table-column field="toLocation" :title="$t('pubGicSet.ToLocation')" show-header-overflow="ellipsis"
                                  show-overflow="ellipsis">
                    <template v-slot="{ row }">
                        <a-auto-complete style="width: 100%;" @search="handleSearch"
                                         :placeholder="$t('publicLang.PleaseSelect')" size="small" v-model="row.toLocation">
                            <template slot="dataSource">
                                <a-select-option v-for="item in completeData" :key="item.locationCode">{{item.locationName}}</a-select-option>
                            </template>
                        </a-auto-complete>
                    </template>
                </vxe-table-column>
                <vxe-table-column :title="$t('generic.operate')" width="150" show-header-overflow="ellipsis"
                                  show-overflow="ellipsis" v-if="isCancelMoveEvent">
                    <template v-slot="{ row }">
                        <img @click="deleteRows(row)" style="margin-left: 4px" class="sbxs"
                             src="../../../assets/img/ss-delete.png" width="22" height="22">
                    </template>
                </vxe-table-column>
            </vxe-table>
        </a-modal>
        <adjust-advan ref="MoveAdvan" :searTableUid="moveSearTableUid" :adjustParHeaderId="moveHeaderUid"
                      :waseCode="moveWarehouse" v-on:getAdjustData="getAdjustData" :ajtype="adjust"></adjust-advan>
    </div>
</template>
<script>
    import ajax from '../../../api/ajax'
    import cookie from '../../../api/cookie'
    import api from '../../../api/url'
    import adjustAdvan from './adjustAdvanSearch/adjustAdvanSearch.vue'
    export default {
        components: {
            adjustAdvan
        },
        data() {
            return {
                ifCancel: true,
                ifSearch: true,
                visible: false,
                form: this.$form.createForm(this),
                tableData: [],
                movelogicSelectData: [],
                moveReasonSelectData: [],
                wareHouseSelect: [],
                moveHeaderUid: "",
                moveSearTableUid: "",
                adjust: 'invMoveDetail',
                completeData: [],
                moveWarehouse: '', // ware code select
                isCancelMoveEvent: true,
                wareHourseDis: false,
                isSaveClick: true,
                //                chang 事件
                remarksVal: '',
                moveLogicVal: '',
                moveReasonVal: '',
                movePatwaytype: '',
                editInvMoveHeader: {},
                type: '',
                editType: '',
                dataType: "",
                pageSizeOptions: ['10', '20', '30', '40', '100', '200', '500', '1000'],
                pagingTotal: 0, // 总数
                pagingSize: Number.parseInt(sessionStorage.getItem('pageSize') || '30'), // 条数
                currentVal: 1, // 页数
                topLocation:"",
            }
        },
        methods: {
            onShowSizeChange(current, pageSize) {
                this.currentVal = current;
                this.pagingSize = pageSize;
                this.changePage();
            },
            //      表格分页
            tableChangePage(current) {
                this.currentVal = current;
                this.changePage();
            },

            moveWarehouseChange(val) {
                this.moveWarehouse = val
            },
            moveLogicChange(val) {
                this.moveLogicVal = val
            },
            moveReasonChange(val) {
                this.moveReasonVal = val
            },
            moveHandleCancel() {
                this.visible = false
                this.wareHourseDis = false
                this.tableData = []
                this.isCancelMoveEvent = true
                this.remarksVal = ''
                this.ifCancel = true
                this.ifSearch = true
                this.isSaveClick = true
                this.moveHeaderUid = ''
                this.form.resetFields();
                this.editInvMoveHeader = {}
                this.topLocation = ""
            },
            show(type, editType) {
                this.type = type;
                this.editType = editType;
                this.adjust = type == 'Move' ? 'invMoveDetail' : type == 'moveGener' ? 'invMoveDetail' : 'puatWay'
                this.movePatwaytype = type == 'moveGener' ? 'Move' : type
                this.visible = true
                // this.init()
                if (type == 'moveGener') {
                    ajax.get(api.INVENTORYINVMOVEHEADER, {
                        uid: editType
                    }).then(res => {
                        if (res.code == 501) {
                            this.visible = false
                            this.$customMessage.error(res.msg);
                            return
                        }
                        this.editInvMoveHeader = res.data.invMoveHeader
                        this.wareHourseDis = true
                        this.moveLogicVal = res.data.invMoveHeader.logic
                        this.moveReasonVal = res.data.invMoveHeader.reasonCode
                        this.moveHeaderUid = res.data.invMoveHeader.uid
                        this.moveSearTableUid = res.data.invMoveHeader.gmcUid
                        this.remarksVal = res.data.invMoveHeader.remarks
                        this.moveWarehouse = res.data.invMoveHeader.whsCode

                        ajax.get(api.INVENTORYINVMOVE, {
                            uid: this.moveHeaderUid
                        }).then(res => {
                            this.tableData = res.data
                        })
                        if (this.editInvMoveHeader.status == '90') {
                            this.isCancelMoveEvent = false
                            this.ifSearch = false
                            this.isSaveClick = false
                            this.ifCancel = false
                        } else if (this.editInvMoveHeader.status == '10') {
                            this.ifCancel = false
                            this.ifSearch = false
                            this.isSaveClick = false
                            this.isCancelMoveEvent = false
                        }
                    })
                    return
                }
                if (editType != '' && editType != undefined) {
                    //                    move Edit
                    if (editType.mark == 'Move') {
                        ajax.post(api.EDITINVRNTORYINVSAVE, editType).then(res => {
                            if (res.code == 501) {
                                this.visible = false
                                this.$customMessage.error(res.msg);
                                return
                            }
                            this.editInvMoveHeader = res.data.invMoveHeader

                            this.wareHourseDis = true
                            this.moveHeaderUid = res.data.invMoveHeader.uid
                            this.moveSearTableUid = res.data.invMoveHeader.gmcUid
                            this.remarksVal = res.data.invMoveHeader.remarks
                            this.moveWarehouse = res.data.invMoveHeader.whsCode
                            ajax.get(api.INVENTORYINVMOVE, {
                                uid: this.moveHeaderUid
                            }).then(res => {
                                this.tableData = res.data
                            })
                            if (this.editInvMoveHeader.status == '90') {
                                this.isCancelMoveEvent = false
                                this.ifSearch = false
                                this.isSaveClick = false
                                this.ifCancel = false
                            } else if (this.editInvMoveHeader.status == '10') {
                                this.ifCancel = false
                                this.ifSearch = false
                                this.isSaveClick = false
                                this.isCancelMoveEvent = false
                            }
                        })
                    } else {


                        ajax.post(api.EXTENDERINVMOVE, editType).then(res => {
                            this.editInvMoveHeader = res.data.invMoveHeader
                            this.wareHourseDis = true
                            this.moveHeaderUid = res.data.invMoveHeader.uid
                            this.moveSearTableUid = res.data.invMoveHeader.gmcUid
                            this.remarksVal = res.data.invMoveHeader.remarks
                            this.moveWarehouse = res.data.invMoveHeader.whsCode
                            this.dataType = res.data.invMoveHeader.dataType
                            this.currentVal = 1   // 重置回1
                            this.changePage()
                            if (this.editInvMoveHeader.status == '90') {
                                this.isCancelMoveEvent = false
                                this.ifSearch = false
                                this.isSaveClick = false
                                this.ifCancel = false
                            } else if (this.editInvMoveHeader.status == '10') {
                                this.ifCancel = false
                                this.ifSearch = false
                                this.isSaveClick = false
                                this.isCancelMoveEvent = false
                            }
                            if (this.editInvMoveHeader.status == '00' || this.editInvMoveHeader.status ==
                                '05') {
                                this.ifCancel = false
                                this.ifSearch = false
                                this.isSaveClick = false
                                this.isCancelMoveEvent = true
                            }
                        })
                    }

                }
            },

            changePage() { // 切换页码
                let params = {};
                params.uid = this.moveHeaderUid;
                if (this.dataType == 'PUTAWAY') {
                    params.pageNum = this.currentVal
                    params.pageSize = this.pagingSize
                }

                ajax.get(api.INVENTORYINVMOVE, params).then(res => {
                    if (this.dataType == 'PUTAWAY') {
                        this.tableData = res.data.data
                        this.pagingTotal = res.data.pagingTotal;
                    } else {
                        this.tableData = res.data
                    }
                })
            },

            //            初始化获取 个个下拉data
            init() {
                ajax.get(api.USERDROPDOWNWHS).then(res => {
                    if (res.code == 200) {
                        this.wareHouseSelect = res.data
                    }
                })
                ajax.get(api.MOVELOGICSELECT).then(res => {
                    this.movelogicSelectData = res.data
                })
                ajax.get(api.MOVEREASONSELECT).then(res => {
                    this.moveReasonSelectData = res.data
                })
            },
            //            header save
            saveMoveHeader() {
                this.form.validateFields((err, val) => {
                    if (!err) {
                        let params = {
                            whsCode: val.warehouse,
                            remarks: this.remarksVal,
                            logic: val.moveLogic,
                            reasonCode: val.moveReason,
                            dataType: this.movePatwaytype == 'Move' ? '' : 'PUTAWAY'
                        }
                        if (this.moveHeaderUid != '') {
                            params.uid = this.moveHeaderUid
                            let arr = []
                            let data = this.tableData
                            for (let i in data) {
                                arr.push({
                                    qty: data[i].moveQty,
                                    toLocation: data[i].toLocation,
                                    uid: data[i].uid,
                                    originalTolocation: data[i].originalTolocation
                                })
                            }
                            params.updateInvDetailVos = arr
                        }
                        ajax.post(api.INVMOVEHEADER, params).then(res => {
                            if (res.code == 200) {
                                this.$message.success(res.msg);
                                this.moveHeaderUid = res.data.headerUid
                                this.moveSearTableUid = res.data.gmcUid
                                this.moveWarehouse = res.data.whsCode
                                this.wareHourseDis = true
                                ajax.get(api.INVENTORYINVMOVE, {
                                    uid: this.moveHeaderUid
                                }).then(res => {
                                    this.tableData = res.data
                                })
                                this.$emit('saveEmit', 'true')
                            } else {
                                this.$customMessage.error(res.msg)
                            }

                        })
                    }
                })
            },
            //            move cancel
            moveCancel() {
                ajax.post(api.INVENTORYMOVECANCEL, {
                    uid: this.moveHeaderUid
                }).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.msg)
                        this.isCancelMoveEvent = false
                        this.ifSearch = false
                        this.isSaveClick = false
                        this.ifCancel = false
                    } else {
                        this.$customMessage.error(res.msg)
                    }
                })
            },
            addMoveTable() {
                this.$refs.MoveAdvan.show()
            },
            getAdjustData(val) {
                this.tableData = val
            },
            deleteRows(row) {
                for (let i in this.tableData) {
                    if (this.tableData[i].uid == row.uid) {
                        this.tableData.splice(i, 1)
                    }
                }
                ajax.post(api.DELINVMOVEDETAIL, {
                    uid: row.uid,
                    headerUid: this.moveHeaderUid,
                    originalTolocation: row.originalTolocation
                }).then(res => {
                    if (res.code == 200) {
                        ajax.get(api.INVENTORYINVMOVE, {
                            uid: this.moveHeaderUid
                        }).then(res => {
                            this.tableData = res.data
                        })
                        this.$message.success(res.msg)
                    } else {
                        this.$customMessage.error(res.msg)
                    }
                })
            },
            handleSearch(value) {
                if (value.length < 4) {
                    return
                }
                let params = {
                    whsCode: this.moveWarehouse,
                    keyword: value,
                }
                ajax.post(api.INVENTORYLOCATION, params).then(res => {
                    this.completeData = res.data
                })
            },
            confirmMove() {

                let params = {
                    logic: this.moveLogicVal,
                    remarks: this.remarksVal,
                    uid: this.moveHeaderUid,
                    updateInvDetailVos: [],
                    whsCode: this.moveWarehouse,
                    reasonCode: this.moveReasonVal,
                    dataType: this.movePatwaytype == 'Move' ? '' : 'PUTAWAY'
                }
                let updateInvDetailVos = []
                let data = this.tableData
                for (let i in data) {
                    updateInvDetailVos.push({
                        qty: data[i].moveQty,
                        toLocation: this.topLocation.length > 0 ? this.topLocation : data[i].toLocation,
                        uid: data[i].uid,
                        originalTolocation: data[i].originalTolocation
                    })
                }
                params.updateInvDetailVos = updateInvDetailVos
                ajax.post(api.MOVECONFIRMINVENTORY, params).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.msg)
                        this.ifCancel = false
                        this.ifSearch = false
                        this.isSaveClick = false
                        this.isCancelMoveEvent = false
                        if (params.dataType == 'PUTAWAY') {
                            this.show(this.type, this.editType)
                        }
                        this.topLocation = ""
                    } else {
                        this.$customMessage.error(res.msg)
                    }
                })
            }
        }
    }
</script>
